import { ShieldAlert } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { t } from '@/i18n';

/**
 * Graceful landing for a 403 from any fiscal-admin endpoint (user without a
 * 'fiscal' module grant on this company) — the sidebar already hides the
 * tab in the normal case, but a direct URL or a mid-session grant change
 * can still land here, and it shouldn't look like a crash.
 */
export function FiscalAccessDenied() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <ShieldAlert className="text-muted-foreground size-5" />
          {t('errors.accessDenied')}
        </CardTitle>
      </CardHeader>
      <CardContent className="text-muted-foreground text-sm">
        {t('fiscal.accessDenied.description')}
      </CardContent>
    </Card>
  );
}
